import type { IBasketItem } from '../modules/basket/models';

export const normalizeLimit = (raw?: number | null) =>
  raw == null || raw === 0 ? null : Math.max(1, Math.min(100, raw));

const getPid = (x: any) =>
  String(x?.productId ?? x?.id ?? x?.item?.productId ?? x?.item?.id ?? '');

export const inBasketQtyForProduct = (items: IBasketItem[], product: any) => {
  const key = getPid(product);
  if (!key) return 0;
  return items.reduce(
    (acc, it) => acc + (getPid(it) === key ? it.quantity || 0 : 0),
    0
  );
};
